var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomErrorClass, ErrorSeverity } from '../errors';
import { hasCustomAttribute, isHttpImageResponse, isHttpQuickReplyResponse, isHttpTextResponse, normalizeHttpImageResponse, normalizeHttpQuickReplyResponse, } from './HTTPConnection.utils';
export class HTTPConnection {
    constructor(options) {
        this.url = options.url;
        this.authenticationToken = options.authenticationToken;
        this.onConnect = options.onConnect;
        this.onDisconnect = options.onDisconnect;
        this.onBotResponse = options.onBotResponse;
        this.onSessionConfirm = options.onSessionConfirm;
    }
    connect() {
        this.onConnect();
        this.onSessionConfirm();
    }
    normalizeResponse(data) {
        return data.map(message => {
            if (isHttpQuickReplyResponse(message)) {
                return normalizeHttpQuickReplyResponse(message);
            }
            if (hasCustomAttribute(message) && !isHttpQuickReplyResponse(message)) {
                return message.custom;
            }
            if (isHttpImageResponse(message)) {
                return normalizeHttpImageResponse(message);
            }
            if (isHttpTextResponse(message)) {
                return { text: message.text };
            }
            return message;
        });
    }
    sendMessage(message, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers();
            if (this.authenticationToken) {
                headers.append('Authorization', `Bearer ${this.authenticationToken}`);
            }
            return fetch(`${this.url}/webhooks/rest/webhook`, {
                method: 'POST',
                headers,
                body: JSON.stringify({ sender: sessionId, message }),
            })
                .then(response => {
                if (!response.ok) {
                    throw new CustomErrorClass(ErrorSeverity.Error, 'Network response error', response.statusText);
                }
                return response.json();
            })
                .then(data => {
                this.normalizeResponse(data).forEach((message) => {
                    this.onBotResponse(message);
                });
            })
                .catch(_ => {
                throw new CustomErrorClass(ErrorSeverity.Error, 'Server error');
            });
        });
    }
    disconnect() {
        this.onDisconnect();
    }
    sessionRequest(_sessionId) {
    }
    reconnection() {
    }
}
//# sourceMappingURL=HTTPConnection.js.map